import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { reportErrorToTelegram } from '@/services/errorReporter'

const app = createApp(App)

// Handler global de erros do Vue (captura erros em componentes, watchers, lifecycle hooks)
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err, info);
  const componentName = vm?.$options?.name || vm?.$options?.__name || 'Desconhecido';
  reportErrorToTelegram({
    error: `[Vue] ${err.message || err}`,
    stack: err.stack || '',
    component: `${componentName} (${info})`,
    url: window.location.href
  });
};

// Handler global de erros não capturados do JavaScript (erros fora do Vue)
window.addEventListener('error', (event) => {
  // Ignora erros de scripts externos ou extensões
  if (event.filename && !event.filename.includes(window.location.origin)) return;
  // Ignora "Script error." genérico — ruído de scripts cross-origin (fontes, extensões, etc.)
  if (event.message === 'Script error.' || event.message === 'Script error') return;
  
  reportErrorToTelegram({
    error: `[JS Global] ${event.message}`,
    stack: event.error?.stack || `${event.filename}:${event.lineno}:${event.colno}`,
    component: 'window.onerror',
    url: window.location.href
  });
});

// Handler de Promises rejeitadas não tratadas
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message = reason?.message || String(reason);
  
  // Ignora erros de sessão expirada (já tratados no api.js)
  if (message === 'Sessão expirada') return;
  // Ignora erros de rede genéricos que já são mostrados via toast
  if (message === 'Failed to fetch') return;
  
  reportErrorToTelegram({
    error: `[Promise] ${message}`,
    stack: reason?.stack || '',
    component: 'unhandledrejection',
    url: window.location.href
  });
});

app.use(store).use(router).mount('#app')
